import { TruckIcon, GiftIcon, LeafIcon, MessageCircleIcon } from 'lucide-react';
import { founder } from '../../data/content';
import { useSite } from '../../contexts/SiteContext';
import { giftsBesidesShipping } from '../../data/gifts';
import { freeShippingLine } from '../../data/policies';
import { euro } from '../../core/format/currency';
import type { SiteSettings } from '../../core/types/site';

/** Altijd uit de actuele instellingen (useSite), zodat een andere staffel hier vanzelf klopt. */
function badges(site: SiteSettings) {
  const gifts = giftsBesidesShipping(site.giftTiers, site.policy.freeShippingFrom);
  const giftLine = gifts.map(t => `${t.title.toLowerCase()} vanaf ${euro(t.threshold)}`).join(' · ').replace(/^./, c => c.toUpperCase());
  return [{
    icon: TruckIcon,
    label: freeShippingLine(site.policy.freeShippingFrom)
  }, ...(giftLine ? [{
    icon: GiftIcon,
    label: giftLine
  }] : []), {
    icon: LeafIcon,
    label: '100% vegan, boom per product'
  }, {
    icon: MessageCircleIcon,
    label: `Gratis persoonlijk advies van ${founder.firstName}`
  }];
}

/** Vier beloftes in één rustige regel, op shell: het toonverschil scheidt, geen randlijnen. */
export function TrustBadges() {
  const site = useSite();
  return <section aria-label="Onze beloftes" className="bg-shell" data-id="element-8802" data-mp="uh21tw049rsu">
      <ul className="mx-auto grid max-w-content gap-x-8 gap-y-4 px-6 py-8 sm:grid-cols-2 lg:grid-cols-4 lg:px-10" data-id="element-8803" data-mp="ze29ucgj14ml">
        {badges(site).map(({
        icon: Icon,
        label
      }) => <li key={label} className="flex items-center gap-3" data-id="element-8804" data-mp="1n2blwmnxue0j">
            <Icon className="h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-8805" data-mp="1s2r0tinvbtkm" />
            <span className="text-[14px] leading-snug text-muted" data-id="element-8806" data-mp="1d5grofyp6zs2">{label}</span>
          </li>)}
      </ul>
    </section>;
}